'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _v = require('./v1');

var _v2 = _interopRequireDefault(_v);

var _v3 = require('./v2');

var _v4 = _interopRequireDefault(_v3);

var _fullscreen = require('@wix/photography-client-lib/dist/src/versioning/features/fullscreen');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenMobileBar = function (_React$Component) {
  (0, _inherits3.default)(FullscreenMobileBar, _React$Component);

  function FullscreenMobileBar(props) {
    (0, _classCallCheck3.default)(this, FullscreenMobileBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenMobileBar.__proto__ || (0, _getPrototypeOf2.default)(FullscreenMobileBar)).call(this, props));

    _this.isNewMobileLayout = _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout();
    return _this;
  }

  (0, _createClass3.default)(FullscreenMobileBar, [{
    key: 'render',
    value: function render() {
      return this.isNewMobileLayout ? _react2.default.createElement(_v4.default, this.props) : _react2.default.createElement(_v2.default, this.props);
    }
  }]);
  return FullscreenMobileBar;
}(_react2.default.Component);

exports.default = FullscreenMobileBar;